<script setup lang="ts">
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";
import { TuButton } from "@tinyurldev/tu-ui-vue";

import useTranslation from "@Composables/useTranslation";

//
// Setup
const { __ } = useTranslation();
const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const isMobileView = breakpoints.smallerOrEqual("xl");

//
// Props
interface Props {
  isEnabling?: boolean;
}

withDefaults(defineProps<Props>(), {
  isEnabling: false,
});

//
// Emit
interface Events {
  (e: "enable"): void;
}

const emit = defineEmits<Events>();
</script>

<template>
  <div class="two-factor-setup">
    <p class="two-factor-setup__description">
      {{ __("security_settings.two_factor_setup.description") }}
    </p>

    <TuButton
      class="_enable"
      :label="__('security_settings.two_factor_setup.enable')"
      :is-disabled="isEnabling"
      :is-block="isMobileView"
      @click="emit('enable')"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/border.scss" as border;
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.two-factor-setup {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  gap: spacing.$xxs;
  padding: spacing.$xxs;

  background-color: color.$background-secondary;
  border-radius: border.$medium-radius;
  border: border.$primary;

  &__description {
    margin: 0;

    font-size: typography.$base-font-size;
    font-weight: typography.$font-weight-medium;
    line-height: typography.$base-line-height;
  }
}
</style>
